// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3cev9{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background:#078285;border-radius:8px;color:#0d0d0d;font-size:12px;font-size:1.2rem;font-weight:600;justify-content:center;line-height:2;padding:.4rem 1.2rem}._2ngX8{color:#fff}._1iB3E{background:#e0fff7;color:#127e68}._3q-u5{background:#feefef;color:#da1818}._1seUD{background:#fdf9e6;color:#806b20}", ""]);
// Exports
exports.locals = {
	"chip": "_3cev9",
	"chip--inactive": "_2ngX8",
	"chip--success": "_1iB3E",
	"chip--error": "_3q-u5",
	"chip--pending": "_1seUD"
};
module.exports = exports;
